

import React, { useState } from 'react';
import '../../../../assets/css/student/dashboard/history.css';
import StudentLayout from '../../../../layouts/student/StudentLayout';

const DonationHistory = () => {
  const [donations] = useState([
    {
      id: 1,
      amount: '12,000',
      type: 'fee Support',
      date: '20-Jan-2026',
      ngo: 'EduCare NGO',
      donor: 'Ayaan Ahmad'
    },
    {
      id: 2,
      amount: '15,000',
      type: 'books support',
      date: '21-Jan-2026',
      ngo: "Knowledge Foundation",
      donor: 'Sania Khan'
    },
    {
      id: 3,
      amount: '10,000',
      type: 'uniform support',
      date: '22-Jan-2026',
      ngo: 'Future Builders',
      donor: 'Faizan Malik'
    },
    {
      id: 4,
      amount: '8,000',
      type: 'fee support',
      date: '23-Jan-2026',
      ngo: 'Tech Education NGO',
      donor: 'Ayaan Ahmad'
    }
  ]);

  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(3); // 3 items per page to show pagination with 4 items

  const totalAmount = donations.reduce((sum, d) => sum + d.amount, 0);
  const totalDonations = donations.length;
  const cashDonations = donations.filter(d => d.type === 'Cash').length;

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDonations = donations.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(donations.length / itemsPerPage);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <StudentLayout>
      <div className="dh-donation-container">
        {/* Header */}
        <header className="dh-donation-header">
          <div className="dh-header-content">
            <div className="dh-header-icon">
              <svg viewBox="0 0 64 64" fill="none">
                <path d="M32 54L12 34C8 30 8 24 12 20C16 16 22 16 26 20L32 26L38 20C42 16 48 16 52 20C56 24 56 30 52 34L32 54Z" fill="white"/>
                <circle cx="32" cy="42" r="3" fill="#2563eb"/>
              </svg>
            </div>
            <div className="dh-header-text">
              <h1>Donation History</h1>
              <p>Approved & Completed Donations Record</p>
            </div>
          </div>
        </header>

        {/* Summary Cards */}
        <div className="dh-summary-section">
          <div className="dh-summary-card dh-card-total">
            <div className="dh-card-icon">Rs</div>
            <div className="dh-card-info">
              <h3>Rs {totalAmount.toLocaleString()}</h3>
              <p>Total Amount</p>
            </div>
          </div>
          <div className="dh-summary-card dh-card-count">
            <div className="dh-card-icon">📊</div>
            <div className="dh-card-info">
              <h3>{totalDonations}</h3>
              <p>Total Donations</p>
            </div>
          </div>
          <div className="dh-summary-card dh-card-cash">
            <div className="dh-card-icon">💵</div>
            <div className="dh-card-info">
              <h3>{cashDonations}</h3>
              <p>Cash Donations</p>
            </div>
          </div>
        </div>

        {/* Donation Table */}
        <div className="dh-table-container">
          <table className="dh-donation-table">
            <thead>
              <tr>
                <th>Amount</th>
                <th>Type</th>
                <th>Date Received</th>
                <th>NGO</th>
                <th>Donor</th>
              </tr>
            </thead>
            <tbody>
              {currentDonations.map((donation) => (
                <tr key={donation.id}>
                  <td className="dh-amount-cell">Rs {donation.amount.toLocaleString()}</td>
                  <td>
                    <span className={`dh-type-badge ${donation.type.toLowerCase()}`}>
                      {donation.type}
                    </span>
                  </td>
                  <td>{donation.date}</td>
                  <td className="dh-ngo-cell">{donation.ngo}</td>
                  <td className="dh-donor-cell">{donation.donor}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination Controls */}
          <div className="dh-pagination-container">
            <div className="dh-pagination-info">
              Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, donations.length)} of {donations.length} entries
            </div>
            
            <div className="dh-pagination-controls">
              <button 
                className="dh-pagination-btn dh-prev-btn" 
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Previous
              </button>

              <div className="dh-pagination-numbers">
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => paginate(index + 1)}
                    className={`dh-pagination-number ${currentPage === index + 1 ? 'active' : ''}`}
                  >
                    {index + 1}
                  </button>
                ))}
              </div>

              <button 
                className="dh-pagination-btn dh-next-btn" 
                onClick={nextPage}
                disabled={currentPage === totalPages}
              >
                Next
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </StudentLayout>
  );
};

export default DonationHistory;








